import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';

import { ControlSettingTemplatesService } from '../shared/services/control-setting-templates.service';
import { ToastService } from '@captiveaire/toast';


interface AuditHistoryDialogData {
    audit: CASLink.Ui.ViewModel.ControlAudit.ControlAuditViewModel;
}

@Component({
    selector: 'dl-audit-history-dialog',
    templateUrl: './audit-history-dialog.component.html',
    styleUrls: ['./audit-history-dialog.component.scss']
})
export class AuditHistoryDialogComponent {

    public static $name: string = 'auditHistoryDialog';
    public templateKey: string = '';

    treeControl = new NestedTreeControl<CASLink.Ui.ViewModel.ControlAudit.ControlAuditChangeNodeViewModel>(node => node.children);
    dataSource = new MatTreeNestedDataSource<CASLink.Ui.ViewModel.ControlAudit.ControlAuditChangeNodeViewModel>();
    audit: CASLink.Ui.ViewModel.ControlAudit.ControlAuditViewModel;

    constructor(
        private dialogRef: MatDialogRef<AuditHistoryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AuditHistoryDialogData,
        private controlSettingTemplatesService: ControlSettingTemplatesService,
        private toastService: ToastService
    ) {
        this.dataSource.data = data.audit.changesTree;
        this.audit = data.audit;
        this.treeControl.dataNodes = data.audit.changesTree;
        this.treeControl.expandAll();
    }

    hasChild = (_: number, node: CASLink.Ui.ViewModel.ControlAudit.ControlAuditChangeNodeViewModel) => !!node.children && node.children.length > 0;

    public onOkClick() {
        this.dialogRef.close();
    }


}
